import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    margin: '0px 0px 24px'
  },
  cardsRow: {
    display: 'flex',
    gap: theme.spacing(3),
    margin: '0 0 24px'
  },
  card: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: 'calc((100% - 48px) / 3)',
    background: theme.palette.common.white,
    borderRadius: theme.spacing(),
    padding: theme.spacing(4)
  },
  carteraIcon: {
    width: theme.spacing(9),
    height: theme.spacing(9),
    background: 'rgba(40,167,69,0.1)',
    borderRadius: theme.spacing(),
    marginRight: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  collectedIcon: {
    width: theme.spacing(9),
    height: theme.spacing(9),
    background: theme.palette.badge.success.bg,
    color: theme.palette.badge.success.text,
    borderRadius: theme.spacing(),
    marginRight: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  pendingIcon: {
    width: theme.spacing(9),
    height: theme.spacing(9),
    background: theme.palette.badge.warning.bg,
    color: theme.palette.badge.warning.text,
    borderRadius: theme.spacing(),
    marginRight: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 24,
    fontWeight: 800
  }
}));
